import { render, staticRenderFns } from "./AddBulletinsModal.vue?vue&type=template&id=5a968016&"
import script from "./AddBulletinsModal.vue?vue&type=script&lang=js&"
export * from "./AddBulletinsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBulletinsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports